export default __webpack_public_path__ + "c44f060a29994f3972aeed925d9e2f95.jpg";